


export interface IFilterItem {
  id:any;
  viewname: string;
  icon: any; 
  /**
   * Value is the original reference
   */
  value: any;
  position: number;
}

export class FilterItem implements IFilterItem {
  id:any;
  viewname: string;
  icon: any;
  
  /**
   * Value is the original reference
   */
  value: any;
  position: number=0;
}
